import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',

    '& .table-root': {
      maxHeight: ({ adjust }) => adjust && 'calc(100svh - 14rem)',
      overflowY: ({ adjust }) => adjust && 'auto'
    }
  },

  add: {
    zIndex: ({ adjust }) => (adjust ? 1 : 0),
    display: 'flex',
    alignItems: 'center',
    marginTop: ({ adjust }) => (adjust ? '-1rem' : '0'),
    borderBottom: '0.0625rem solid rgba(230, 234, 236, 0.9)',
    padding: '10px 0',
    color: theme.palette.textAlt,
    backgroundColor: '#F9FAFC'
  },

  addButton: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '1.5rem',
    cursor: 'pointer',
    opacity: '0.455',

    '& .icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '0.5rem',
      fontSize: theme.size.base
    }
  },

  addArea: {
    flex: '1',
    paddingLeft: '1.5rem',

    '& input': {
      border: 'none',
      width: 'calc(100% - 1.5rem)',
      outline: 'none',
      backgroundColor: 'transparent',
      fontSize: 'inherit'
    }
  },

  checkbox: {
    marginRight: '0.5rem',
    padding: '0'
  }
}))

export default useStyles
